import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=cef0d97c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=cef0d97c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef0d97c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cef0d97c')) {
      api.createRecord('cef0d97c', component.options)
    } else {
      api.reload('cef0d97c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=cef0d97c&scoped=true&", function () {
      api.rerender('cef0d97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gE1Q67ct3146/JS/comp/PopupBox.vue"
export default component.exports